import moment from 'moment'
import {EdgesSalelogSet} from '../../graphql/types/ventasType'

interface ITabProps {
  log: EdgesSalelogSet[]
}

const COLORS = ['warning', 'primary', 'info', 'danger', 'dark', 'success', 'secondary'] as const

export const TabActivity: React.FC<ITabProps> = ({log}) => {
  const getColor = (idx: number) => {
    const i = idx % COLORS.length
    return COLORS[i]
  }
  if (log.length === 0) {
    return (
      <div className='d-flex align-items-center justify-content-center' style={{height: '50vh'}}>
        <div>
          <h4>No hay actividad registrada</h4>
        </div>
      </div>
    )
  }
  return (
    <div>
      <div className='card-header align-items-center border-0 mt-4'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='fw-bold mb-2 text-dark'>Actividad</span>
          <span className='text-muted fw-semibold fs-7'>
            A continuación se muestra toda la actividad relacionada con esta venta
          </span>
        </h3>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body pt-5'>
        {/* begin::Timeline */}
        <div className='timeline-label'>
          {/* begin::Item */}
          {log.map(({node}, i) => (
            <div key={node.id} className='timeline-item'>
              {/* begin::Label */}
              <div className='timeline-label fw-bold text-gray-800'>
                {moment(node.created).format('hh:mm A')}
              </div>
              {/* end::Label */}
              {/* begin::Badge */}
              <div className='timeline-badge'>
                <i className={`fa fa-genderless text-${getColor(i)} fs-1`}></i>
              </div>
              {/* end::Badge */}
              {/* begin::Text */}
              <div className='fw-mormal timeline-content text-muted ps-3'>
                <span style={{color: 'black', fontWeight: 'bolder'}}>
                  {node.user.firstName} {node.user.lastName}:
                </span>
                <p className='p-0 m-0'>{node.description}</p>
                <p className='p-0 m-0'>{moment(node.created).format('DD MMMM YYYY')}</p>
              </div>
              {/* end::Text */}
            </div>
          ))}
          <div className='timeline-item'>
            {/* begin::Label */}
            <div className='timeline-label fw-bold text-gray-800 fs-6'>FIN</div>
            {/* end::Label */}
            {/* begin::Badge */}
            <div className='timeline-badge'>
              <i className='fa fa-genderless text-warning fs-1'></i>
            </div>
            {/* end::Badge */}
            {/* begin::Text */}

            {/* end::Text */}
          </div>
          {/* end::Item */}
          {/* end::Item */}
        </div>
        {/* end::Timeline */}
      </div>
    </div>
  )
}
